import EnhancedTab from 'lib/designSystem/TabSimulation';
import { Warranty } from 'lib/types/models';
import File from 'pages/Finance/Components/Financing/SGR/components/File';
import React from 'react';

import WarrantySummary from './WarrantySummary';

const WarrantyDetailTabs: React.FC<{
  warranty: Warranty;
}> = ({ warranty }) => {
  const isActive = warranty.status === 'ACTIVE';
  const tabs = [
    {
      label: 'Resumen',
      component: <WarrantySummary warranty={warranty} pruffConnect />,
    },
    ...(isActive
      ? [
          {
            label: 'Documento',
            component: <File warranty={warranty} />,
            disabled: warranty.status === 'LEAD',
          },
        ]
      : []),
  ];

  const title = warranty.folioId
    ? `Garantía ${warranty.displayId}`
    : `Cotización ${warranty.id}`;

  return <EnhancedTab title={title} tabs={tabs} />;
};

export default WarrantyDetailTabs;
